import React from 'react'

function Opony() {
  return (
    <div>Opony</div>
  )
}

export default Opony